"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectAction = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const Flex_1 = require("@amzn/atoz-web/Flex");
const DetailedRadio_1 = require("@amzn/atoz-web/DetailedRadio");
const Text_1 = require("@amzn/atoz-web/Text");
const MessageBanner_1 = require("@amzn/atoz-web/MessageBanner");
const taaConfigs_1 = require("../../../../contexts/taaConfigs");
const logger_1 = require("../../../../logger");
const BIAnalytics_1 = __importDefault(require("../../../../utils/BIAnalytics/BIAnalytics"));
const SelectActionTypes_1 = require("./SelectActionTypes");
const useSelectAction_1 = require("./hooks/useSelectAction");
const SpinnerOverlay_1 = require("../../../../components/SpinnerOverlay");
const context_1 = require("../../context");
const PunchWorkflowTypes_1 = require("../../PunchWorkflowTypes");
const SelectAction = () => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { selectedDateTime, action: selectedAction, setAction: setSelectedAction, setShowErrorFallback, setIsCurrentStepValid, setNewPunchDate, setNewPunchTime } = (0, context_1.usePunchWorkflowContext)();
    const { clientName } = (0, taaConfigs_1.useTaaConfigsContext)();
    const dimensions = {
        ClientName: clientName,
        ClientType: logger_1.ClientType.WEB
    };
    const { isLoading, actionOptions, warningMessage, error } = (0, useSelectAction_1.useSelectAction)({
        isWeb: true
    });
    (0, react_1.useEffect)(() => {
        BIAnalytics_1.default.arriveSelectActionInPW();
    }, []);
    (0, react_1.useEffect)(() => {
        setShowErrorFallback(!!error);
    }, [error]);
    (0, logger_1.useComponentLoadedMetrics)({
        metricNames: {
            countMetricName: logger_1.METRICS.PUNCH_WORKFLOW_SELECT_ACTION_STEP_RENDERED.COUNT
        },
        isComponentLoaded: !isLoading
    });
    return (react_1.default.createElement(Flex_1.Flex, { flexDirection: 'column', dataTestId: SelectActionTypes_1.SELECT_ACTION_DATA_TEST_IDS.SELECT_ACTION },
        react_1.default.createElement(Text_1.Text, { fontSize: 'T200', color: 'neutral90' }, selectedDateTime.toFormat('LLLL dd, yyyy')),
        react_1.default.createElement(SpinnerOverlay_1.SpinnerOverlay, { isLoading: isLoading },
            react_1.default.createElement(Flex_1.Flex, { flexDirection: 'column', margin: { top: 'S300', bottom: 'S300' }, gridGap: 'S300' },
                !!warningMessage && (react_1.default.createElement(MessageBanner_1.MessageBanner, { dataTestId: SelectActionTypes_1.SELECT_ACTION_DATA_TEST_IDS.WARNING_BANNER, iconAltText: t('time_and_attendance_Warning'), type: MessageBanner_1.MessageBannerType.Informational }, warningMessage)),
                actionOptions.map((action) => action.featureAvailable && (react_1.default.createElement(DetailedRadio_1.DetailedRadio, { dataTestId: SelectActionTypes_1.SELECT_ACTION_DATA_TEST_IDS[action.value.toUpperCase()], key: action.value, name: SelectActionTypes_1.SELECT_ACTION_DATA_TEST_IDS.SELECT_ACTION, titleText: action.titleText, "aria-label": action.ariaLabel, checked: selectedAction === action.value, onClick: () => {
                        BIAnalytics_1.default.selectActionInPW();
                        setSelectedAction(action.value);
                        logger_1.logger.emitCountMetric({
                            metricName: logger_1.METRICS[`PUNCH_WORKFLOW_SELECT_ACTION_${action.value.toUpperCase()}`].COUNT,
                            dimensions
                        });
                        setIsCurrentStepValid(true);
                        setNewPunchDate(action.value === PunchWorkflowTypes_1.PUNCH_WORKFLOW_ACTIONS.ADD
                            ? selectedDateTime
                            : undefined);
                        setNewPunchTime('');
                    }, disabled: action.disabled })))))));
};
exports.SelectAction = SelectAction;
